import React from 'react';

const Error500 = () => (
  <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-br from-red-800 via-red-900 to-black text-white">
    <h1 className="text-6xl font-bold mb-4">500</h1>
    <p className="text-xl mb-8">Ranjithkumar's Server Error. Something went wrong.</p>
    <a href="/" className="px-6 py-3 bg-red-600 hover:bg-red-700 rounded-full text-lg font-medium shadow-md transition-transform hover:scale-105">Go Home</a>
  </div>
);

export default Error500;
